import {
  getControllerData,
  humpToLinethrough
} from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'
import {getPropertyValueInRootStyle} from '@/globalPopagation.js'
import {isNotNumber} from "@/components/common/controlBar/controlBarDialog/metaComponent/height/utils.js";
import {
  getValueOfMuiltLanguagesJson,
  getValueOfMuiltLanguagesJson2,
} from "@/components/widgets/nav/repeatNumber.js";
import {walkNodeUp} from "@/composables/newUtils.js";


//数据转样式
function deepCopy(arg) {
  if (typeof arg === 'object') {
    const result = Array.isArray(arg) ? [] : {}
    for (const key in arg) {
      if (arg[key] === null) {
        result[key] = null
      } else {
        result[key] = deepCopy(arg[key])
      }
    }
    return result
  } else {
    return arg
  }
}

//
export function calculateShadowX(deg, distance) {
  deg = 270 - deg
  //计算坐标值
  const arc = ((deg - 90) * Math.PI * 1) / 180,
    x = Math.ceil(distance * 1 * Math.sin(arc))

  return x
}

self.calculateShadowX = calculateShadowX

export function calculateShadowY(deg, distance) {
  deg = 270 - deg
  //计算坐标值
  const arc = ((deg - 90) * Math.PI * 1) / 180,
    y = Math.ceil(distance * 1 * Math.cos(arc))

  return y
}

self.calculateShadowY = calculateShadowY

function computeColumnWidthOfListV2(columnLength, columnGapValue, columnGapUnit) {
  var res = `calc((100% - ${(columnLength - 1) * columnGapValue}${columnGapUnit}) / ${columnLength})`
  return res
}

self.computeColumnWidthOfListV2 = computeColumnWidthOfListV2

//通过json的值得到key
export function getReverseValueInJson(json, value) {
  var res
  for (var key in json) {
    if (json[key] === value) {
      res = key
    }
  }
  return res
}

// 是否是css
export function isBelongToCSS(componentType) {
  return (
    componentType === 'fontSize' ||
    componentType === 'fontFamily' ||
    componentType === 'color' ||
    componentType === 'textStyle' ||
    componentType === 'textAlign' ||
    componentType === 'lineHeight' ||
    componentType === 'letterSpace' ||
    componentType === 'margin' ||
    componentType === 'marginAndAuto' ||
    componentType === 'brightness' ||
    componentType === 'zIndex' ||
    componentType === 'padding' ||
    componentType === 'borderRadius' ||
    componentType === 'border' ||
    componentType === 'safeWidth' ||
    componentType === 'shadow' ||
    componentType === 'background' ||
    componentType === 'ratio' ||
    componentType === 'ratio2' ||
    componentType === 'diffWidth' ||
    componentType === 'diffWidth2' ||
    componentType === 'layoutSwitch' ||
    componentType === 'colMargin' ||
    componentType === 'colMargin2' ||
    componentType === 'rowMargin' ||
    componentType === 'width' ||
    componentType === 'maxWidth' ||
    componentType === 'height' ||
    componentType === 'wordMargin' ||
    componentType === 'colPadding' ||
    componentType === 'colPadding2' ||
    componentType === 'rowGap' ||
    componentType === 'transformScale' ||
    componentType === 'textOverflow' ||
    componentType === 'transverseMargin' ||
    componentType === 'transverseMargin2' ||
    componentType === 'listItemLength' ||
    componentType === 'order' ||
    componentType === 'flexAlign' ||
    componentType === 'flexVerticalAlign' ||
    componentType === 'floatTransverse' ||
    componentType === 'columsLengthOfListV2' ||
    componentType === 'rowsLengthOfListV2' ||
    componentType === 'gridColumns' ||
    componentType === 'gapOfListV2' ||
    componentType === 'imageAspectRatio' ||
    componentType === 'objectFit' ||
    componentType === 'textTheme' ||
    componentType === 'upperLowerCase' ||
    componentType === 'transform' ||
    componentType === 'moduleHeight' ||
    componentType === 'gridSize' ||
    componentType === 'textShadow' ||
    componentType === 'zoom' ||
    componentType === 'hollowColor'
  )
}

export function isThreeEnds(value) {
  var res = false
  if (
    Object.prototype.toString.call(value) === '[object Object]' &&
    Object.keys(value).includes('diannao')
  ) {
    res = true
  }
  return res
}

//便利所有原子组件
export function walkAllMetaComponentList(node, callback) {
  if (!node || !node.controllerModule) return
  walkControllerAllGroup(node.controllerModule, (group, key) => {
    group.children.forEach((metaComponent) => {
      callback && callback(metaComponent, key, group)
    })
  })
}

//处理样式数据
export function createStyleDataFromVariousParts(node, deviceMode) {
  let data = {}
  walkAllMetaComponentList(node, (walkedMetaComponent, parent) => {
    if (isBelongToCSS(walkedMetaComponent.componentType)) {
      var item = walkedMetaComponent
      if (Object.prototype.toString.call(item.name) === '[object Object]') {
        for (var key in item.name) {
          var customKey = item.name[key]
          var cssKey = getReverseValueInJson(item.name, customKey)
          if (item.value) {
            var value = (() => {
              if (isThreeEnds(item.value[cssKey])) {
                return item.value[cssKey][deviceMode]
              } else {
                return item.value[cssKey]
              }
            })()
            data[customKey] = value
          }
        }
      } else {
        console.log('error name')
      }
    }
  })

  return data
}

const getBraces = (string) => {
  var arr = []
  var startBrace = undefined
  var endBrace = undefined
  for (var i = 0; i < string.length; i++) {
    if (string[i] === '[') {
      startBrace = i
    }
    if (string[i] === ']') {
      endBrace = i
      arr.push(string.slice(startBrace, endBrace + 1))
    }
  }
  return arr
}

//通过属性值获取节点
export function getNodesBySpecailProperty(propery, value, fromList) {
  var matches = []
  loopArr(
    (() => {
      if (fromList) {
        return fromList
      } else {
        if (self.rootList) {
          return self.rootList
        }

        if (mm.store.state.hasList && mm.store.state.hasList.length) {
          return mm.store.state.hasList
        } else {
          return self.hasList
        }
      }
    })(),
    (node) => {
      if (node[propery] === value) {
        matches.push(node)
      }
    }
  )
  return matches
}

// 通过id获取节点信息
export function getNodeById(id) {
  var match = getNodesBySpecailProperty('id', id)[0]
  return match
}

// 获取父级节点
export function getParentNode(node) {
  if (!node || !node.id) {
    return null
  }
  var arr = node.id.split('_')
  arr.pop()
  var parentId = arr.join('_')
  return getNodeById(parentId)
}

//  向上冒泡找到父节点
export function bubblingNode(node, fn) {
  if (!node) {
    return
  }
  let isContinue = true
  while (isContinue) {
    var parentNode = getParentNode(node)
    if (parentNode) {
      fn(parentNode)
      node = parentNode
    } else {
      isContinue = false
    }
  }
}

//给样式合适的默认值
function parseFitValueIfEmpty(varyName, style) {
  if (
    varyName.match('orderTopColor') ||
    varyName.match('askBackgroundColor') ||
    varyName.match('orderBottomColor') ||
    varyName.match('orderLeftColor') ||
    varyName.match('orderRightColor') ||
    varyName.match('hadowColor')
  ) {
    if (style[varyName] === '' || style[varyName] === null) {
      return 'transparent'
    }
  }
  if (varyName.match('overFontStyle')) {
    if (style[varyName] === '' || style[varyName] === null) {
      return 'normal'
    }
  }
  if (varyName.match('overFontWeight')) {
    if (style[varyName] === '' || style[varyName] === null) {
      return 'normal'
    }
  }
  if (varyName.match('overTextDecoration')) {
    if (style[varyName] === '' || style[varyName] === null) {
      return 'none'
    }
  }

  return style[varyName]
}

function resolveUnit(res, varyName, index, cssContent, style) {
  if (varyName.match('Unit')) {
    if (!isValidOfValue(index, cssContent, style)) {
      res = ''
    }
  }
  return res
}

function isValidOfValue(index, cssContent, style) {
  var res = true
  var arr = cssContent.substring(0, index).replace(/\s+/g, ' ').split(' ')
  var last = arr[arr.length - 1]

  if (last === 'auto') {
    res = false
  }

  if (last[0] === '[' && last[last.length - 1] === ']') {
    var varName = last.substring(1, last.length - 1)
    if (style[varName] === 'auto') {
      res = false
    }
  }

  return res
}

function getVaryNameFromBrace(brace) {
  return brace.replace('[', '').replace(']', '')
}

//解析节点样式转成css
const parseNodeStyle = (node, deviceMode, pcResponse, isRtl) => {
  var style = createStyleDataFromVariousParts(node, deviceMode)
  var stylesMap = deepCopy(node.styleModule)

  stylesMap = (() => {
    var json = {}
    for (let stylesMapKey in stylesMap) {
      var newKey = stylesMapKey.replace(/\.\%/g, '.' + node.id)
      json[newKey] = stylesMap[stylesMapKey]
    }
    return json
  })()

  for (let stylesMapKey in stylesMap) {
    var braces = getBraces(stylesMap[stylesMapKey])
    braces.forEach((brace) => {
      var varyName = getVaryNameFromBrace(brace)
      if (typeof style[varyName] !== 'undefined') {
        var flag = '[' + varyName + ']'
        if (stylesMap[stylesMapKey].indexOf(flag) !== -1) {
          var cssContent = stylesMap[stylesMapKey].trim()
          stylesMap[stylesMapKey] = cssContent.replace(
            new RegExp('\\' + '[' + varyName + '\\]', 'g'),
            (matched, index) => {
              var res = parseFitValueIfEmpty(varyName, style)
              res = resolveUnit(res, varyName, index, cssContent, style)

              if (varyName.match('askBackgroundColor')) {
                if (!isGradient(res)) {
                  res = 'linear-gradient(to right, ' + res + ' 0%, ' + res + ' 100%)'
                }
              }

              if (isGradient(res) && !isValueOfVar(res)) {
                var obj = parseStringToObj(res)
                obj.gradients.forEach((gradient) => {
                  if (!gradient.color) {
                    gradient.color = 'transparent'
                  }
                })
                res = parseObjToString(obj)
              }
              res = getValueOfMuiltLanguagesJson2(res, isRtl)
              return res
            }
          )
        }
      } else {
        if (varyName.indexOf('(') !== -1) {
          var [fnName, ...fnParams] = varyName.replace('(', ',').replace(')', '').split(',')

          var res = eval(
            (() => {
              var res = fnName + '('
              fnParams.forEach((fnParam, fnParamIndex) => {
                var realValue = style[fnParam]

                if (fnName === 'computeColumnWidthOfListV2') {
                  if (fnParam === 'listV2_gapValue') {
                    if (!style[fnParam]) {
                      realValue = '0'
                    }
                  }
                  if (fnParam === 'listV2_gapUnit') {
                    realValue = `"${realValue}"`
                  }
                }

                if (fnParamIndex === fnParams.length - 1) {
                  res += realValue + ')'
                } else {
                  res += realValue + ','
                }
              })
              return res
            })()
          )
          var cssContent = stylesMap[stylesMapKey].trim()
          stylesMap[stylesMapKey] = cssContent.replace('[' + varyName + ']', res)
        }
      }
    })
  }
  var res = (() => {
    var innerText = (() => {
      var innerText = ''
      for (var key in stylesMap) {
        innerText += key
        innerText += '{'
        innerText += stylesMap[key]
        innerText += '}'
      }
      return innerText
    })()

    function useHoverWhole(cssRule, conditionFn) {
      var getHoverWholeNode = (node) => {
        var res = false
        walkNodeUp(node, (walkedNode) => {
          if (conditionFn(walkedNode) && !node.notHoverWhole) {
            res = walkedNode
          }
        })
        return res
      }

      var hoverWholeNode = getHoverWholeNode(node)
      if (hoverWholeNode) {
        for (var key in stylesMap) {
          if (key.match(':hover')) {
            var cssSelector = key.replace(':hover', '')
            if (!node.unsave_hoverWholeExclude) {
              innerText += `.${hoverWholeNode.id}${cssRule} ${cssSelector}{${stylesMap[key]}}`
            }
          }
        }
      }
    }

    //  整体hover  start
    useHoverWhole(':hover', (walkedNode) => {
      return walkedNode.unsave_hoverWhole
    })
    //  整体hover  end

    //  点击使用hover  start
    useHoverWhole('.specailActiveHover', (walkedNode) => {
      return walkedNode.unsave_clickUseHoverWhole
    })
    //  点击使用hover  end

    innerText = addImportant(innerText, node)
    //自定义样式  start
    // if (node.data.css) {
    //   innerText += node.data.css
    // }
    //自定义样式  end

    return innerText.replace(/\n/g, '')
  })()

  if (deviceMode === 'diannao' && pcResponse) {
    res = shinkPxToRem(res)
  }

  return res
}

function shinkPxToRem(string) {
  string = string.replace(/\d+px/g, (match) => {
    return parseInt(match) / 10 + 'rem'
  })
  return string
}

function isEmptyColorofGradient(gradient) {
  var res = false
  if (!gradient.match(' ')) {
    if (gradient.match('%')) {
      res = true
    }
  }
  return res
}

export function parseStringToObj(string) {
  if (isGradient(string)) {
    var cacheJson = {}
    string = string.substring(0, string.length - 1)
    string = string.replace(/rgba?\([\d\,\s\.]+\)/g, (matched) => {
      var rgbaId = 'rgbaTemp' + Date.now() + Math.random()
      cacheJson[rgbaId] = matched
      return rgbaId
    })

    string = string.replace(/var\(--[\w\d]+\)/g, (matched) => {
      var varId = 'rgbaTemp' + Date.now() + Math.random()
      cacheJson[varId] = matched
      return varId
    })

    var arr = string.replace('linear-gradient(', '').replace(')', '').split(',')
    arr = arr.map((item) => {
      return item.trim()
    })
    var [direction, ...gradients] = arr

    var json = {
      type: string.split('(')[0],
      direction: (() => {
        if (direction === 'to right') {
          return '90deg'
        }
        return direction
      })(),
      gradients: gradients.map((gradient) => {
        if (isEmptyColorofGradient(gradient)) {
          return {
            color: '',
            stop: gradient.replace('%', '')
          }
        } else {
          return {
            color: (() => {
              if (gradient.split(' ')[0].startsWith('rgbaTemp')) {
                return cacheJson[gradient.split(' ')[0]]
              } else {
                return gradient.split(' ')[0]
              }
            })(),
            stop: gradient.split(' ')[1].replace('%', '')
          }
        }
      })
    }

    return json
  } else {
    var json = {
      type: 'linear-gradient',
      direction: '90deg',
      gradients: [
        {
          color: string,
          stop: 100
        }
      ]
    }

    return json
  }
}

export function parseObjToString(obj) {
  return `${obj.type}(${obj.direction}, ${obj.gradients
    .map((gradient) => {
      return `${gradient.color} ${gradient.stop}%`
    })
    .join(',')})`
}

// 获取hover代码
function getHoverCodeBlock(startIndex, innerText) {
  var matchIndex = innerText.indexOf(':hover', startIndex)
  if (matchIndex > -1) {
    var copyInnerText = innerText
    var startIndexOfBlock, endIndexOfBlock
    for (var i = 0; i < copyInnerText.length; i++) {
      var wanderTowardIndex = matchIndex + i
      var wanderRearIndex = matchIndex - i

      if (copyInnerText[wanderTowardIndex] === '}') {
        if (!endIndexOfBlock) {
          endIndexOfBlock = wanderTowardIndex + 1
        }
      }
      if (copyInnerText[wanderRearIndex] === '}') {
        if (!startIndexOfBlock) {
          startIndexOfBlock = wanderRearIndex + 1
        }
      }
    }

    for (var i = endIndexOfBlock; i > startIndexOfBlock; i--) {
      if (copyInnerText[i] === ';') {
        copyInnerText =
          copyInnerText.substring(0, i) + ' !important;' + copyInnerText.substring(i + 1)
      }
    }
    return [copyInnerText, matchIndex]
  } else {
    return [innerText, matchIndex]
  }
}

// 添加！important
function addImportant(innerText, node) {
  var startIndex = 0
  var isContinue = true
  while (isContinue) {
    if (startIndex > -1) {
      var [innerText, matchIndex] = getHoverCodeBlock(startIndex + 1, innerText)
      startIndex = matchIndex
      innerText = innerText
    } else {
      isContinue = false
    }
  }

  return innerText
}

//  清除字母
function clearLetters(cssString) {
  let isContinue = true
  while (isContinue) {
    var match = cssString.match(/\[\w+\]/)
    if (match) {
      cssString = chipOutUnvalidCssRule(cssString)
    } else {
      isContinue = false
    }
  }

  return cssString
}

//// 首字母大写
export function firstLetterUpperCase(word) {
  var [firsetLetter, ...rest] = word.split('')
  var res = [firsetLetter.toUpperCase(), ...rest].join('')
  return res
}

//找边界索引
function findBorderIndex(cssString, index, type, callback) {
  let isContinue = true
  while (isContinue) {
    if (type === 'pre') {
      index--
    } else {
      index++
    }

    if (callback().includes(cssString[index])) {
      isContinue = false
    }
  }

  return index + 1
}

//// 获取controller中的指定数据
export const abstractDataFromMetaComponentList = (metaComponentList) => {
  var newList = []
  walkTree(metaComponentList, (treeItem) => {
    if (!(treeItem.children && treeItem.children.length)) {
      newList.push(treeItem)
    }
  })

  let data = {}
  newList.forEach((item) => {
    for (var key in item.name) {
      var customKey = item.name[key]
      var cssKey = getReverseValueInJson(item.name, customKey)
      if (item.value) {
        var value = item.value[cssKey]
        data[customKey] = value
      }
    }
  })
  return data
}
export const abstractDataFromMetaComponentList2 = (metaComponentList) => {
  var newList = []
  walkTree(metaComponentList, (treeItem) => {
    if (!(treeItem.children && treeItem.children.length)) {
      newList.push(treeItem)
    }
  })

  let data = {}
  newList.forEach((item) => {
    if (!data.hasOwnProperty(item.englishTitle)) {
      data[`${item.englishTitle}::${item.componentType}`] = {}
    }

    for (var key in item.name) {
      var customKey = item.name[key]
      var cssKey = getReverseValueInJson(item.name, customKey)
      if (item.value) {
        var value = item.value[cssKey]
        data[`${item.englishTitle}::${item.componentType}`][customKey] = value
      }
    }
  })
  return data
}

//切除无效的css规则
function chipOutUnvalidCssRule(cssString) {
  var match = cssString.match(/\[\w+\]/)
  var startIndex = match.index
  var endIndex = startIndex + (match[0].length - 1)

  startIndex = findBorderIndex(cssString, startIndex, 'pre', () => {
    return [';', '{']
  })
  endIndex = findBorderIndex(cssString, endIndex, 'rear', () => {
    return [';', '}']
  })

  cssString = cssString.substring(0, startIndex) + cssString.substring(endIndex)

  return cssString
}

// 递归数组
export const loopArr = (arr, callback) => {
  if (!arr || !Array.isArray(arr)) {
    return
  }
  arr.forEach((node) => {
    callback && callback(node)

    if (node?.list) {
      loopArr(node.list, callback)
    }
  })
}

// 递归节点
export function walkTree(arr, callback) {
  arr.forEach((item) => {
    callback(item)
    if (item.children && item.children.length) {
      walkTree(item.children, callback)
    }
  })
}

export function createMedia({ start, end, percent }) {
  return `@media (min-width: ${start}) and (max-width:${end}) {
      html {
        font-size: calc(10px * ${Number(percent.replace('%', '')) / 100}) !important;
      }
  }`
}

//解析样式
export function parseStyleInWorker(deviceMode, isRender, rootList, globalFont, isInWorker, mediaQueryConfig, pcResponse, isRtl) {
  var json = {}
  //浮顶样式  start
  var commonStyle = `.commonFixedTop{
            position: fixed;
            width: 100%;
            z-index: 100;
            top: 0px;
            left: 0px;
        }
        `

  mediaQueryConfig.forEach((config) => {
    commonStyle += createMedia(config)
  })

  commonStyle = commonStyle.replace(/\n/g, '')

  // :root {
  //     --globalFont: ${globalFont};
  // }
  //浮顶样式  end
  loopArr(rootList, (node) => {
    var res = parseNodeStyle(node, deviceMode, pcResponse)
    res = clearLetters(res)

    res = res.replace(/background-image:\s*url\(\)/g, (match) => {
      return 'background-image: '
    })
    res = res.replace(/background-image:\s*url\(transparent\)/g, (match) => {
      return 'background-image: '
    })

    // 兼容：background-color 有值且 background-image 无值时置为 none；background-image 有值时保持原值
    res = res.replace(/(?:([^^{}]*?)\{([^}]*?)\})/g, (match, selector, body) => {
      var bgImageMatch = body.match(/background-image:\s*([^;]+);?/)
      var bgImageVal = bgImageMatch ? bgImageMatch[1].trim() : ''
      var hasBgImage =
        bgImageVal !== '' &&
        bgImageVal !== 'none' &&
        bgImageVal !== 'url()' &&
        bgImageVal !== 'url(transparent)'
      if (hasBgImage) {
        return match
      }
      var bgColorMatch = body.match(/background-color:\s*([^;]+);?/)
      var hasBgColor =
        bgColorMatch && bgColorMatch[1].trim() !== '' && bgColorMatch[1].trim() !== 'transparent'
      // 无图片时统一清除残留的图片相关属性（repeat/size/position/attachment），
      // 避免覆盖页面级背景(content/index.vue buildEffectCss)的效果样式
      var cleanedBody = body
      cleanedBody = cleanedBody.replace(/\s*background-repeat:[^;]*;?/g, '')
      cleanedBody = cleanedBody.replace(/\s*background-size:[^;]*;?/g, '')
      cleanedBody = cleanedBody.replace(/\s*background-position:[^;]*;?/g, '')
      cleanedBody = cleanedBody.replace(/\s*background-attachment:[^;]*;?/g, '')
      if (hasBgColor) {
        cleanedBody = cleanedBody.replace(/background-image:\s*[^;]*;?/g, 'background-image: none;')
      } else {
        // 既无图片也无颜色时，清除所有背景残留属性，让节点能 fallback 到父级/页面级背景
        cleanedBody = cleanedBody.replace(/\s*background-image:[^;]*;?/g, '')
        cleanedBody = cleanedBody.replace(/\s*background-color:[^;]*;?/g, '')
      }
      return selector + '{' + cleanedBody + '}'
    })

    res = res.replace(/(autopx|auto%|autorem)/g, (match) => {
      return 'auto'
    })
    

    json[node.id] = res
  })
  json.commonStyle = commonStyle
  return json
}

//是否有hover属性，没有则补充
export function isHoverWord(word, isNeedHover) {
  var res
  if (isNeedHover) {
    res = 'hover' + firstLetterUpperCase(word)
  } else {
    res = word
  }
  return res
}

try {
  self.addEventListener(
    'message',
    function (e) {
      if (e.data.renoToken === 'sdasfdfsddfsddfas===') {
        var { deviceMode, isRender, rootList, resolveId, globalFont, rootStyle, mediaQueryConfig, pcResponse, isRtl } = e.data
        self.deviceMode = deviceMode
        self.rootList = rootList
        self.rootStyle = rootStyle
        var res = parseStyleInWorker(deviceMode, isRender, rootList, globalFont, true, mediaQueryConfig, pcResponse, isRtl)
        self.postMessage(
          JSON.stringify({
            data: res,
            resolveId
          })
        )
      }
    },
    false
  )
} catch (e) {
  self.close()
}

// 遍历指定属性
function walkControllerSomeKeyGroup(controller, key, callback) {
  if (controller[key] && controller[key].metaComponentList) {
    var groups = controller[key].metaComponentList
    groups.forEach((group) => {
      callback(group)
    })
  }
}

//判断根据componentType和element判断是否有hover
//判断设计和划过是否都有相同属性，如果有则设计中的该属性可展示同步复选框
export function isHoverHas(controller, componentType, element) {
  var res = false
  walkControllerSomeKeyGroup(controller, 'hover', (group) => {
    group.children.forEach((metaComponent) => {
      if (metaComponent.componentType === componentType && metaComponent.element === element) {
        res = true
      }
    })
  })
  return res
}

// hover 内某个原子功能是否隐藏
export function isHoverHidden(controller, componentType, element) {
  var res = false
  walkControllerSomeKeyGroup(controller, 'hover', (group) => {
    group.children.forEach((metaComponent) => {
      if (metaComponent.componentType === componentType && metaComponent.element === element) {
        if (metaComponent.isHide) {
          res = true
        }
      }
    })
  })
  return res
}

//遍历controller
export function walkControllerAllGroup(controller, callback) {
  Object.keys(controller).forEach((key) => {
    walkControllerSomeKeyGroup(controller, key, (group) => {
      callback(group, key)
    })
  })
}

//判断某个元子功能在哪个父级里面
export function inWhichParent(node, metaComponent) {
  var res = ''
  walkAllMetaComponentList(node, (walkedMetaComponent, parent) => {
    if (metaComponent.id === walkedMetaComponent.id) {
      res = parent
    }
  })
  return res
}

export function isValueOfVar(value) {
  return value.indexOf('var(--') >= 0
}

export function transfomrVarToRgba(value) {
  return getPropertyValueInRootStyle(value.replace('var(', '').replace(')', ''))
}

export function isGradient(value) {
  var res = false

  if (value && value.match) {
    if (value.startsWith('linear-gradient')) {
      res = true
    } else {
      if (value.indexOf('var(--') >= 0) {
        var value2
        if (typeof window === 'undefined') {
          if (self.rootStyle[value.replace('var(', '').replace(')', '')]) {
            value2 = self.rootStyle[value.replace('var(', '').replace(')', '')]
          } else {
            value2 = ''
          }
        } else {
          value2 = getPropertyValueInRootStyle(value.replace('var(', '').replace(')', ''))
        }

        res = value2.match('-gradient')
      } else {
        res = value.match('-gradient')
      }
    }
  }

  return res
}

// 通过组件类型生成css模版
export function createStylePortionByComponentType(node, metaComponent, style, deviceMode) {
  var parent = inWhichParent(node, metaComponent)
  var isNeedHover = parent === 'hover'

  var customName = Object.values(metaComponent.name)[0]

  //var elementName = customName.split('_')[0]
  var elementName = customName.substring(
    0,
    (() => {
      var endFlag = customName.lastIndexOf('_')
      return endFlag
    })()
  )
  var res = ''
  if (metaComponent.componentType === 'background') {
    res = `background-color: ${(() => {
      if (
        metaComponent.value['background-color'] &&
        metaComponent.value['background-color'][deviceMode] &&
        isGradient(metaComponent.value['background-color'][deviceMode])
      ) {
        return ``
      } else {
        return `[${elementName}_${isHoverWord('backgroundColor', isNeedHover)}]`
      }
    })()};
        background-image: ${(() => {
          if (
            metaComponent.value['background-color'] &&
            metaComponent.value['background-color'][deviceMode] &&
            isGradient(metaComponent.value['background-color'][deviceMode])
          ) {
            return `[${elementName}_${isHoverWord('backgroundColor', isNeedHover)}]`
          } else if (
            metaComponent.value['mask-background-color'] &&
            metaComponent.value['mask-background-color'][mm.store.state.deviceMode]
          ) {
            return `[${elementName}_${isHoverWord('maskBackgroundColor', isNeedHover)}],url([${elementName}_${isHoverWord('backgroundImage', isNeedHover)}])`
          } else {
            return `url([${elementName}_${isHoverWord('backgroundImage', isNeedHover)}])`
          }
        })()};
        background-repeat: [${elementName}_${isHoverWord('backgroundRepeat', isNeedHover)}];`

    if (metaComponent.value.hasOwnProperty('background-effect')) {
      if (metaComponent.value['background-effect'][deviceMode]) {
        if (metaComponent.value['background-effect'][deviceMode] === 'repeatX') {
          res += `background-repeat: repeat;
        background-size: auto auto;`
        } else if (
          metaComponent.value['background-effect'][deviceMode] === 'ratioEnlargeOrShrink'
        ) {
          res += `background-repeat: no-repeat;
        background-size: contain;`
        } else if (metaComponent.value['background-effect'][deviceMode] === 'fit') {
          res += `background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;`
        } else if (metaComponent.value['background-effect'][deviceMode] === 'originSize') {
          res += `background-repeat: no-repeat;`
        }
      }
    }
    res += `background-attachment: [${elementName}_${isHoverWord('backgroundAttachment', isNeedHover)}];`
    res += `background-position: [${elementName}_${isHoverWord('backgroundPosition', isNeedHover)}];`
    if (metaComponent.englishTitle === 'mask_background') {
      res = `--mask-background: ${metaComponent.value['background-color'][mm.store.state.deviceMode]};`
    }
  } else if (metaComponent.componentType === 'textTheme') {
  } else if (metaComponent.componentType === 'transform') {
    res = `transform: rotate([${elementName}_${isHoverWord('rotate', isNeedHover)}]deg) skewX([${elementName}_${isHoverWord('skewX', isNeedHover)}]deg) skewY([${elementName}_${isHoverWord('skewY', isNeedHover)}]deg);`
  } else if (metaComponent.componentType === 'fontFamily') {
    res = `font-family: [${elementName}_${isHoverWord('fontFamily', isNeedHover)}];`
  } else if (metaComponent.componentType === 'fontSize') {
    res = `font-size: ${parseCssValueWhoContainsUnit(
      `[${elementName}_${isHoverWord('fontSize', isNeedHover)}]`,
      `[${elementName}_${isHoverWord('fontSizeUnit', isNeedHover)}]`,
      'fontSize',
      metaComponent,
      deviceMode
    )};`
  } else if (metaComponent.componentType === 'color') {
    res = `color: [${elementName}_${isHoverWord('color', isNeedHover)}];`
  } else if (metaComponent.componentType === 'textStyle') {
    res = `font-weight: [${elementName}_${isHoverWord('fontWeight', isNeedHover)}];
        font-style: [${elementName}_${isHoverWord('fontStyle', isNeedHover)}];
        text-decoration: [${elementName}_${isHoverWord('textDecoration', isNeedHover)}];
        text-underline-position: auto;
        `
  } else if (metaComponent.componentType === 'textAlign') {
    const textAlignValue = metaComponent.value['text-align'][mm.store.state.deviceMode]
    if (textAlignValue === 'justify') {
      res = `text-align: [${elementName}_${isHoverWord('textAlign', isNeedHover)}];text-align-last: [${elementName}_${isHoverWord('textAlign', isNeedHover)}];`
    } else {
      res = `text-align: [${elementName}_${isHoverWord('textAlign', isNeedHover)}];`
    }
  } else if (metaComponent.componentType === 'lineHeight') {
    res = `line-height: ${parseCssValueWhoContainsUnit(
      `[${elementName}_${isHoverWord('lineHeight', isNeedHover)}]`,
      `[${elementName}_${isHoverWord('lineHeightUnit', isNeedHover)}]`,
      'lineHeight',
      metaComponent,
      deviceMode
    )};`
  } else if (metaComponent.componentType === 'letterSpace') {
    res = `letter-spacing: ${parseCssValueWhoContainsUnit(
      `[${elementName}_${isHoverWord('letterSpacing', isNeedHover)}]`,
      `[${elementName}_${isHoverWord('letterSpacingUnit', isNeedHover)}]`,
      'letterSpacing',
      metaComponent,
      deviceMode
    )};`
  } else if (
    metaComponent.componentType === 'margin' ||
    metaComponent.componentType === 'marginAndAuto'
  ) {
    res = `margin-top: ${parseCssValueWhoContainsUnit(
      `[${elementName}_${isHoverWord('marginTop', isNeedHover)}]`,
      `[${elementName}_${isHoverWord('marginUnit', isNeedHover)}]`,
      'marginTop',
      metaComponent,
      deviceMode
    )};
        margin-bottom: ${parseCssValueWhoContainsUnit(
          `[${elementName}_${isHoverWord('marginBottom', isNeedHover)}]`,
          `[${elementName}_${isHoverWord('marginUnit', isNeedHover)}]`,
          'marginBottom',
          metaComponent,
          deviceMode
        )};
        margin-left: ${parseCssValueWhoContainsUnit(
          `[${elementName}_${isHoverWord('marginLeft', isNeedHover)}]`,
          `[${elementName}_${isHoverWord('marginUnit', isNeedHover)}]`,
          'marginLeft',
          metaComponent,
          deviceMode
        )};
        margin-right: ${parseCssValueWhoContainsUnit(
          `[${elementName}_${isHoverWord('marginRight', isNeedHover)}]`,
          `[${elementName}_${isHoverWord('marginUnit', isNeedHover)}]`,
          'marginRight',
          metaComponent,
          deviceMode
        )};
        `
  } else if (metaComponent.componentType === 'brightness') {
    res = `opacity:calc([${elementName}_${isHoverWord('opacity', isNeedHover)}] / 100);filter: brightness([${elementName}_${isHoverWord('brightness', isNeedHover)}]%) contrast([${elementName}_${isHoverWord('contrast', isNeedHover)}]%);`
  } else if (metaComponent.componentType === 'padding') {
    res = `padding:
    ${(() => {
      var res = parseCssValueWhoContainsUnit(
        `[${elementName}_${isHoverWord('paddingTop', isNeedHover)}]`,
        `[${elementName}_${isHoverWord('paddingUnit', isNeedHover)}]`,
        'paddingTop',
        metaComponent,
        deviceMode
      )
      return res
    })()}
    ${parseCssValueWhoContainsUnit(
      `[${elementName}_${isHoverWord('paddingRight', isNeedHover)}]`,
      `[${elementName}_${isHoverWord('paddingUnit', isNeedHover)}]`,
      'paddingRight',
      metaComponent,
      deviceMode
    )}
    ${parseCssValueWhoContainsUnit(
      `[${elementName}_${isHoverWord('paddingBottom', isNeedHover)}]`,
      `[${elementName}_${isHoverWord('paddingUnit', isNeedHover)}]`,
      'paddingBottom',
      metaComponent,
      deviceMode
    )}
    ${parseCssValueWhoContainsUnit(
      `[${elementName}_${isHoverWord('paddingLeft', isNeedHover)}]`,
      `[${elementName}_${isHoverWord('paddingUnit', isNeedHover)}]`,
      'paddingLeft',
      metaComponent,
      deviceMode
    )}
    ;`
  } else if (metaComponent.componentType === 'borderRadius') {
    res = `border-radius:
    ${parseCssValueWhoContainsUnit(
      `[${elementName}_${isHoverWord('borderRadiusLeftTop', isNeedHover)}]`,
      `[${elementName}_${isHoverWord('borderRadiusLeftTopUnit', isNeedHover)}]`,
      'borderRadiusLeftTop',
      metaComponent,
      deviceMode
    )}
     ${parseCssValueWhoContainsUnit(
       `[${elementName}_${isHoverWord('borderRadiusRightTop', isNeedHover)}]`,
       `[${elementName}_${isHoverWord('borderRadiusRightTopUnit', isNeedHover)}]`,
       'borderRadiusRightTop',
       metaComponent,
       deviceMode
     )} ${parseCssValueWhoContainsUnit(
       `[${elementName}_${isHoverWord('borderRadiusRightBottom', isNeedHover)}]`,
       `[${elementName}_${isHoverWord('borderRadiusRightBottomUnit', isNeedHover)}]`,
       'borderRadiusRightBottom',
       metaComponent,
       deviceMode
     )} ${parseCssValueWhoContainsUnit(
       `[${elementName}_${isHoverWord('borderRadiusLeftBottom', isNeedHover)}]`,
       `[${elementName}_${isHoverWord('borderRadiusLeftBottomUnit', isNeedHover)}]`,
       'borderRadiusLeftBottom',
       metaComponent,
       deviceMode
     )};`
  } else if (metaComponent.componentType === 'shadow') {
    res = `box-shadow: [calculateShadowX(${elementName}_${isHoverWord('angleDegrees', isNeedHover)},${elementName}_${isHoverWord('shadowOffset', isNeedHover)})][${elementName}_${isHoverWord('shadowUnit', isNeedHover)}] [calculateShadowY(${elementName}_${isHoverWord('angleDegrees', isNeedHover)},${elementName}_${isHoverWord('shadowOffset', isNeedHover)})][${elementName}_${isHoverWord('shadowUnit', isNeedHover)}] [${elementName}_${isHoverWord('shadowBlur', isNeedHover)}][${elementName}_${isHoverWord('shadowUnit', isNeedHover)}] [${elementName}_${isHoverWord('shadowSpread', isNeedHover)}][${elementName}_${isHoverWord('shadowUnit', isNeedHover)}] [${elementName}_${isHoverWord('shadowColor', isNeedHover)}] ;`
  } else if (metaComponent.componentType === 'textShadow') {
    res = `text-shadow: [calculateShadowX(${elementName}_${isHoverWord('angleDegrees', isNeedHover)},${elementName}_${isHoverWord('shadowOffset', isNeedHover)})][${elementName}_${isHoverWord('shadowUnit', isNeedHover)}] [calculateShadowY(${elementName}_${isHoverWord('angleDegrees', isNeedHover)},${elementName}_${isHoverWord('shadowOffset', isNeedHover)})][${elementName}_${isHoverWord('shadowUnit', isNeedHover)}] [${elementName}_${isHoverWord('shadowBlur', isNeedHover)}][${elementName}_${isHoverWord('shadowUnit', isNeedHover)}] [${elementName}_${isHoverWord('shadowColor', isNeedHover)}] ;`
  } else if (metaComponent.componentType === 'border') {
    res = `border-top: ${parseCssValueWhoContainsUnit(
      `[${elementName}_${isHoverWord('borderTopWidth', isNeedHover)}]`,
      'px',
      'borderTopWidth',
      metaComponent,
      deviceMode
    )} [${elementName}_${isHoverWord('borderTopStyle', isNeedHover)}] [${elementName}_${isHoverWord('borderTopColor', isNeedHover)}];

        border-right: ${parseCssValueWhoContainsUnit(
          `[${elementName}_${isHoverWord('borderRightWidth', isNeedHover)}]`,
          'px',
          'borderRightWidth',
          metaComponent,
          deviceMode
        )} [${elementName}_${isHoverWord('borderRightStyle', isNeedHover)}] [${elementName}_${isHoverWord('borderRightColor', isNeedHover)}];

        border-bottom: ${parseCssValueWhoContainsUnit(
          `[${elementName}_${isHoverWord('borderBottomWidth', isNeedHover)}]`,
          'px',
          'borderBottomWidth',
          metaComponent,
          deviceMode
        )} [${elementName}_${isHoverWord('borderBottomStyle', isNeedHover)}] [${elementName}_${isHoverWord('borderBottomColor', isNeedHover)}];

        border-left: ${parseCssValueWhoContainsUnit(
          `[${elementName}_${isHoverWord('borderLeftWidth', isNeedHover)}]`,
          'px',
          'borderLeftWidth',
          metaComponent,
          deviceMode
        )} [${elementName}_${isHoverWord('borderLeftStyle', isNeedHover)}] [${elementName}_${isHoverWord('borderLeftColor', isNeedHover)}];`
  } else if (metaComponent.componentType === 'safeWidth') {
    res = `margin-left: [${elementName}_${isHoverWord('marginLeft', isNeedHover)}];
        margin-right: [${elementName}_${isHoverWord('marginRight', isNeedHover)}];
        margin-top: [${elementName}_${isHoverWord('marginTop', isNeedHover)}];
        margin-bottom: [${elementName}_${isHoverWord('marginBottom', isNeedHover)}];
        width: [${elementName}_${isHoverWord('width', isNeedHover)}];`
  } else if (metaComponent.componentType === 'colMargin') {
    const attribute = getControllerData(node, 'attribute')

    const colLength = attribute.value['self_colLength'][deviceMode]
    res = `
      width: calc( (100% - ([${elementName}_${isHoverWord('colMargin', isNeedHover)}]px) * (${colLength} - 1)) / ${colLength} );
    `
  } else if (metaComponent.componentType === 'colMargin2') {
    res += `margin: 0
    [${elementName}_${isHoverWord('colMargin', isNeedHover)}][${elementName}_${isHoverWord('colMarginUnit', isNeedHover)}];`
  } else if (metaComponent.componentType === 'rowMargin') {
    if (metaComponent.marginType === 'top') {
      res += `margin-top:  [${elementName}_${isHoverWord('rowMargin', isNeedHover)}][${elementName}_${isHoverWord('rowMarginUnit', isNeedHover)}] !important;`
    } else if (metaComponent.marginType === 'right') {
      res += `margin-right:  [${elementName}_${isHoverWord('rowMargin', isNeedHover)}][${elementName}_${isHoverWord('rowMarginUnit', isNeedHover)}] !important;`
    } else {
      res += `margin-bottom:  [${elementName}_${isHoverWord('rowMargin', isNeedHover)}][${elementName}_${isHoverWord('rowMarginUnit', isNeedHover)}] !important;`
    }
  }
  // 有问题
  // else if (metaComponent.componentType === 'colPadding') {
  //   res += `margin: 0
  //   [${elementName}_${isHoverWord('colPadding', isNeedHover)}][${elementName}_${isHoverWord('colPaddingUnit', isNeedHover)}];`
  // }
  else if (metaComponent.componentType === 'colPadding') {
    res += `padding: 0
    [${elementName}_${isHoverWord('colPadding', isNeedHover)}][${elementName}_${isHoverWord('colPaddingUnit', isNeedHover)}] !important;`
  }
  // gap 方式的列间距，会换行
  else if (metaComponent.componentType === 'colPadding2') {
    res += `column-gap:
    [${elementName}_${isHoverWord('colPadding2', isNeedHover)}][${elementName}_${isHoverWord('colPadding2Unit', isNeedHover)}];`
  }
  if (metaComponent.componentType === 'rowGap') {
    res += `row-gap:
    [${elementName}_${isHoverWord('rowGap', isNeedHover)}][${elementName}_${isHoverWord('rowGapUnit', isNeedHover)}];`
  } else if (metaComponent.componentType === 'width') {
    res = `width: [${elementName}_${isHoverWord('width', isNeedHover)}][${elementName}_${isHoverWord('widthUnit', isNeedHover)}];
        `
  } else if (metaComponent.componentType === 'maxWidth') {
    res = `max-width: [${elementName}_${isHoverWord('maxWidth', isNeedHover)}][${elementName}_${isHoverWord('maxWidthUnit', isNeedHover)}];
        `
  } else if (metaComponent.componentType === 'height') {
    if (metaComponent.value.height[deviceMode] === '-webkit-fill-available') {
      res = `height: 100%;
        `
    } else {
      res = `height: [${elementName}_${isHoverWord('height', isNeedHover)}][${elementName}_${isHoverWord('heightUnit', isNeedHover)}];
        `
    }

    if (
      node.componentName === 'container' &&
      !isNotNumber(metaComponent.value.height[deviceMode])
    ) {
      res += `overflow: scroll;`
    }
  } else if (metaComponent.componentType === 'wordMargin') {
    res += `margin-left:  [${elementName}_${isHoverWord('wordMargin', isNeedHover)}]px;`
  } else if (metaComponent.componentType === 'listItemLength') {
    if (metaComponent.widgetName === 'slider_images') {
      const attribute = getControllerData(node, 'attribute')
      const design = getControllerData(node, 'design')
      const colNum = attribute.value['listitem_value'][self.deviceMode || mm.store.state.deviceMode]
      const gap =
        design.value['mz-swiper-wrapper_colPadding2'][self.deviceMode || mm.store.state.deviceMode]
      res = `width: calc( (100% - ${gap}px * (${colNum} - 1)) / ${colNum} );`
    } else {
      res = `width: calc( 100% / [${elementName}_${isHoverWord('value', isNeedHover)}]);`
    }
  } else if (metaComponent.componentType === 'columsLengthOfListV2') {
    res += `grid-template-columns: repeat([${elementName}_${isHoverWord('value', isNeedHover)}], [computeColumnWidthOfListV2(${elementName}_${isHoverWord('value', isNeedHover)},${elementName}_${isHoverWord('gapValue', isNeedHover)},${elementName}_${isHoverWord('gapUnit', isNeedHover)})]);`
  } else if (metaComponent.componentType === 'rowsLengthOfListV2') {
    res += `grid-template-rows: repeat([${elementName}_${isHoverWord('rowValue', isNeedHover)}],1fr);`
  } else if (metaComponent.componentType === 'gridColumns') {
    res += `grid-template-columns: repeat([${elementName}_${isHoverWord('value', isNeedHover)}],1fr);`
  } else if (metaComponent.componentType === 'gridSize') {
    res += `grid-template-columns: [${elementName}_${isHoverWord('columns', isNeedHover)}];`
  } else if (metaComponent.componentType === 'gapOfListV2') {
    res += `column-gap: [${elementName}_${isHoverWord('gapValue', isNeedHover)}][${elementName}_${isHoverWord('gapUnit', isNeedHover)}];`
  }

  // grid布局,控制列数
  else if (metaComponent.componentType === 'transformScale') {
    res = `
    transform:scale(calc([${elementName}_${isHoverWord('transformScale', isNeedHover)}] / 100));
    `
  } else if (metaComponent.componentType === 'textOverflow') {
    res = `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: [${elementName}_${isHoverWord('lineClamp', isNeedHover)}];
    -webkit-box-orient: vertical;
    word-break: break-word;
    `
  } else if (metaComponent.componentType === 'transverseMargin') {
    res = `[${elementName}_${isHoverWord('transverseMargin', isNeedHover)}];`
  } else if (metaComponent.componentType === 'transverseMargin2') {
    res = `[${elementName}_${isHoverWord('transverseMargin', isNeedHover)}];`
  } else if (metaComponent.componentType === 'order') {
    res += `order: [${elementName}_${isHoverWord('order', isNeedHover)}];`
  } else if (metaComponent.componentType === 'flexAlign') {
    res = `
     display: flex;
     align-items: center;
     justify-content: [${elementName}_${isHoverWord('flexAlign', isNeedHover)}];
    `
  } else if (metaComponent.componentType === 'flexVerticalAlign') {
    res = `
     align-items: [${elementName}_${isHoverWord('alignItems', isNeedHover)}];
    `
  } else if (metaComponent.componentType === 'floatTransverse') {
    res = `[${elementName}_${isHoverWord('floatTransverse', isNeedHover)}]`
  } else if (metaComponent.componentType === 'imageAspectRatio') {
    res = `aspect-ratio: [${elementName}_${isHoverWord('imgWidth', isNeedHover)}]/[${elementName}_${isHoverWord('imgHeight', isNeedHover)}];`
  } else if (metaComponent.componentType === 'objectFit') {
    res = `
    object-fit: [${elementName}_${isHoverWord('objectFit', isNeedHover)}];
    `
  } else if (metaComponent.componentType === 'upperLowerCase') {
    res = `
      text-transform: [${elementName}_${isHoverWord('caseValue', isNeedHover)}];
      `
  } else if (metaComponent.componentType === 'zIndex') {
    res = `
      z-index: [${elementName}_${isHoverWord('value', isNeedHover)}];
      `
  } else if (metaComponent.componentType === 'zoom') {
    res = `zoom: [${elementName}_${isHoverWord('zoom', isNeedHover)}];`
  } else if (metaComponent.componentType === 'hollowColor') {
    res = `-webkit-text-stroke:1px [${elementName}_${isHoverWord('hollowColor', isNeedHover)}];`
  }

  var key = `${(() => {
    if (elementName === 'self') {
      return `.%.${elementName}`
    } else {
      return `.% .${elementName}`
    }
  })()}${(() => {
    if (isNeedHover) {
      return ':hover'
    } else {
      return ''
    }
  })()}`

  if (isNeedHover && metaComponent.isCreateHoverClassName) {
    key += ',' + key.replace(':hover', `.enableControllerHover`)
  }

  if (typeof style[key] === 'undefined') {
    style[key] = ''
  }

  if (isNeedHover) {
    if (self.isEnableHoverEffect) {
      style[key] += res
    }
  } else {
    style[key] += res
  }

  return res
}

function getValueByCssKeyInMetaComponent(metaComponent, cssKey, deviceMode) {
  var cssValue =
    metaComponent.value[humpToLinethrough(cssKey)] &&
    metaComponent.value[humpToLinethrough(cssKey)][deviceMode]
  return cssValue
}

function parseCssValueWhoContainsUnit(number, unit, cssKey, metaComponent, deviceMode) {
  const cssValue = getValueByCssKeyInMetaComponent(metaComponent, cssKey, deviceMode)

  if (cssValue && typeof cssValue === 'string' && cssValue.includes('var')) {
    return `calc(${number} * ${(() => {
      if (isBrace(unit)) {
        var varyName = getVaryNameFromBrace(unit)
        var [elementName, cssName] = varyName.split('_')
        unit = getValueByCssKeyInMetaComponent(metaComponent, cssName, deviceMode)
      }

      if (unit === 'px' || unit === 'rem' || unit === '%') {
        return `1${unit}`
      } else {
        return `${unit}`
      }
    })()})`
  } else {
    return `${number}${unit}`
  }
}

function isBrace(string) {
  return string.startsWith('[') && string.endsWith(']')
}
